import React from "react";
const DataLayout = ({ children }: { children: React.ReactNode }) => {
  return <div className="m-5 min-w-[400px]">{children}</div>;
};

export default DataLayout;
